import { Box, Text } from '@approvalmax/ui/src/components';
import { FC } from 'react';

import { Root } from './LineItemFooterLine.styles';
import { LineItemFooterLineProps } from './LineItemFooterLine.types';

/**
 * @deprecated Use redesigned version {@link SummaryLineValues}, {@link SummaryLineTotal}, {@link SummaryLineHeaders}
 */
export const LineItemFooterLine: FC<LineItemFooterLineProps> = (props) => {
    const { qa, label, warning, children } = props;

    return (
        <Root alignItems='center' $warning={warning}>
            <Text font='body' color='midnight70' fontSize='small'>
                {label}
            </Text>

            <Box width={100}>
                <Text font='body' textAlign='right' data-qa={qa} fontSize='small' fontWeight='bold'>
                    {children}
                </Text>
            </Box>
        </Root>
    );
};

LineItemFooterLine.displayName = 'LineItemFooterLine';
